import { render, staticRenderFns } from "./groupSame.vue?vue&type=template&id=a9be54b2&scoped=true"
import script from "./groupSame.vue?vue&type=script&lang=js"
export * from "./groupSame.vue?vue&type=script&lang=js"
import style0 from "./groupSame.vue?vue&type=style&index=0&id=a9be54b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9be54b2",
  null
  
)

export default component.exports